module.exports = __webpack_public_path__ + "img/lock-icon.92158c45.svg";